<template functional>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M17.658 3.23259L9.18538 0.0333752C9.06592 -0.0109216 8.93408 -0.0109216 8.81459 0.0333752L0.34193 3.23259C0.136477 3.30987 0 3.50653 0 3.72643V4.81628C0 5.10776 0.235863 5.34362 0.527344 5.34362H17.4727C17.7641 5.34362 18 5.10776 18 4.81628V3.72643C18 3.50653 17.8635 3.30987 17.658 3.23259Z"
        fill="currentColor"/>
    <path
        d="M2.10938 12.7264C1.52687 12.7264 1.05469 13.1986 1.05469 13.7811V14.3085C1.05469 14.5997 1.2908 14.8358 1.58203 14.8358H5.35018L6.40487 12.7264H2.10938Z"
        fill="currentColor"/>
    <path
        d="M15.8906 12.7264H11.5951L12.6496 14.8358H16.418C16.7092 14.8358 16.9453 14.5997 16.9453 14.3085V13.7811C16.9453 13.1987 16.4731 12.7264 15.8906 12.7264Z"
        fill="currentColor"/>
    <path
        d="M1.05469 15.8905C0.472184 15.8905 0 16.3627 0 16.9452V17.4725C0 17.7638 0.236109 17.9999 0.527344 17.9999H3.76815L4.82284 15.8905H1.05469Z"
        fill="currentColor"/>
    <path
        d="M16.9453 15.8905H13.1768L14.2314 17.9999H17.4726C17.7639 17.9999 18 17.7638 18 17.4725V16.9452C18 16.3627 17.5278 15.8905 16.9453 15.8905Z"
        fill="currentColor"/>
    <path d="M4.74609 6.39847H2.63672V11.6719H4.74609V6.39847Z" fill="currentColor"/>
    <path d="M10.0547 6.39847H7.91016V11.6719H10.0547V6.39847Z" fill="currentColor"/>
    <path d="M15.3633 6.39847H13.2539V11.6719H15.3633V6.39847Z" fill="currentColor"/>
    <path
        d="M10.3807 12.7264H7.58417C6.61262 14.6695 5.93576 16.0232 4.94745 17.9999H13.0525C11.0219 13.9385 11.8545 15.674 10.3807 12.7264Z"
        fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconFund"
}
</script>